import { IonText } from '@ionic/react';
import { FormattedMessage, useIntl } from 'react-intl';

import styles from '@components/client/ClientVerifyEmailInstructions.module.css';
import ButtonLink from '@components/typography/ButtonLink';
import ExternalLink from '@components/typography/ExternalLink';
import InternalLink from '@components/typography/InternalLink';
import { EmailFragment as Email } from '@typing/Generated';

type Client = {
  email: Email;
};

type Props = {
  client?: Client;
  handleUpdateEmail?: () => void;
};

const ClientVerifyEmailInstructions = ({ client, handleUpdateEmail }: Props) => {
  const intl = useIntl();

  return (
    <>
      <div>
        <IonText>
          <FormattedMessage id="models.client.verifyEmail.emailSent" values={{ email: client?.email.email }} />
        </IonText>
      </div>
      <div className={styles.spacing}>
        <IonText>
          <FormattedMessage
            id="models.client.verifyEmail.updateEmail"
            values={{
              update: handleUpdateEmail ? (
                <ButtonLink onClick={handleUpdateEmail}>
                  {intl.formatMessage({ id: 'models.client.verifyEmail.update' })}
                </ButtonLink>
              ) : (
                <InternalLink to="/client/account">
                  {intl.formatMessage({ id: 'models.client.verifyEmail.update' })}
                </InternalLink>
              )
            }}
          />
        </IonText>
      </div>
      <div>
        <IonText>
          <FormattedMessage
            id="models.client.verifyEmail.contactSupport"
            values={{
              support: (
                <ExternalLink href="https://www.withgrayce.com/contact-us">
                  {intl.formatMessage({ id: 'models.client.verifyEmail.support' })}
                </ExternalLink>
              )
            }}
          />
        </IonText>
      </div>
    </>
  );
};

export default ClientVerifyEmailInstructions;
